import { render, staticRenderFns } from "./MailTemplateDialog.vue?vue&type=template&id=aa51792c"
import script from "./MailTemplateDialog.vue?vue&type=script&lang=ts"
export * from "./MailTemplateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports